import { SM_DATA_SUCCESS, SM_DATA_FAILURE, SKIP_MAILBOX_CREATION, SM_DATA_RESET } from '../actions/types';

const initialState = { success: false, source_email: null, display_name: null, target_emails: [], sharedmailboxid: null, skipMailboxCreation: false };

function smData(state = initialState, action) {
    const { payload } = action;
    
    switch (action.type) {
        case SM_DATA_SUCCESS:
        case SM_DATA_FAILURE: 
		case SKIP_MAILBOX_CREATION: {
			return { ...state, ...payload };
        }
        case SM_DATA_RESET:
            return initialState;
        default:
            return state;
    }
}

export default smData;
